import * as Pages from "@/components/Pages";
import * as People from "@/models/people";
import * as React from "react";

import { IconSun, IconMoon, IconDeviceLaptop, Forms, showErrorToast, Page as TurboUIPage } from "turboui";

import classnames from "classnames";

import { useSetTheme, useTheme } from "@/contexts/ThemeContext";
import { PageModule } from "@/routes/types";
import { useNavigate } from "react-router";

import { usePaths } from "@/routes/paths";
export default { name: "AccountAppearancePage", loader: Pages.emptyLoader, Page } as PageModule;

function Page() {
  const paths = usePaths();

  return (
    <TurboUIPage
      title={["Appearance", "Account"]}
      size="small"
      navigation={[
        { to: paths.homePath(), label: "Главная" },
        { to: paths.accountSettingsPath(), label: "Настройки" },
      ]}
    >
      <div className="px-10 py-8">
        <Form />
      </div>
    </TurboUIPage>
  );
}

function Form() {
  const paths = usePaths();
  const currentTheme = useTheme();
  const navigate = useNavigate();

  const form = Forms.useForm({
    fields: {
      theme: currentTheme,
    },
    submit: async () => {
      try {
        await People.updateTheme({ theme: form.values.theme });
        navigate(paths.accountPath());
      } catch {
        showErrorToast("Error", "Failed to update theme");
      }
    },
  });

  return (
    <Forms.Form form={form}>
      <h1 className="text-2xl font-bold">Внешний вид</h1>

      <h2 className="font-bold mt-8">Цветовой режим</h2>
      <p className="text-sm text-content-dimmed">Выбери, должна ли тема быть светлой, темной или следовать настройкам компьютера.</p>

      <div className="grid grid-cols-3 gap-4 mt-4 h-32">
        <ColorModeOption icon={IconSun} title="Всегда светлая" theme="light" />
        <ColorModeOption icon={IconMoon} title="Всегда темная" theme="dark" />
        <ColorModeOption icon={IconDeviceLaptop} title="Как в системе" theme="system" />
      </div>

      <Forms.Submit saveText="Сохранить изменения" />
    </Forms.Form>
  );
}

function ColorModeOption({ theme, icon, title }) {
  const currentTheme = useTheme();
  const setTheme = useSetTheme();

  const className = classnames(
    "rounded",
    "border",
    "flex flex-col items-center justify-center gap-2",
    "p-4",
    "cursor-pointer",
    "hover:bg-surface-accent",
    {
      "bg-surface-dimmed": currentTheme !== theme,
      "border-accent-1": currentTheme === theme,
      "border-surface-outline": currentTheme !== theme,
    },
  );

  const [_, setValue] = Forms.useFieldValue("theme");

  const changeTheme = () => {
    setValue(theme);
    setTheme(theme);
  };

  return (
    <div className={className} onClick={changeTheme} data-test-id={`color-mode-${theme}`}>
      {React.createElement(icon, { size: 32, strokeWidth: 1.5 })}
      <span className="font-semibold">{title}</span>
    </div>
  );
}
